import di from 'di';

import defaultConfig from 'app/config/config.default';
import stagingConfig from 'app/config/config.staging';
import productionConfig from 'app/config/config.production';
import developmentConfig from 'app/config/config.development';

export default function() {

    var config = defaultConfig;
    var envConfig = {};

    if(ENV === 'development') {
        envConfig = developmentConfig;
    }
    else if(ENV === 'staging') {
        envConfig = stagingConfig;
    }
    else if(ENV === 'production') {
        envConfig = productionConfig;
    }

    Object.assign(config, envConfig);
    di.set('config', config);
}
